import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    color: "#193446",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M21.25 11.25a.75.75 0 0 0-.75.75v7.266c0 .69-.56 1.25-1.25 1.25H4.72c-.69 0-1.25-.56-1.25-1.25V4.734c0-.69.56-1.25 1.25-1.25h7.264a.75.75 0 0 0 0-1.5H4.72a2.753 2.753 0 0 0-2.75 2.75v14.53a2.753 2.753 0 0 0 2.75 2.75h14.53a2.753 2.753 0 0 0 2.75-2.75v-7.266a.75.75 0 0 0-.75-.75z" fill="currentColor"/> <path d="M21.94 2.448a.75.75 0 0 0-.69-.462h-6.42a.75.75 0 0 0 0 1.5h4.61L7.949 14.974a.75.75 0 0 0 1.059 1.061l11.491-11.49V9.12a.75.75 0 0 0 1.501 0V2.734a.7.7 0 0 0-.058-.286z" fill="currentColor"/>' }
  })
);